import React from 'react';
import './Policy.css';

const Policy = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1 className="policy-title">QUALITY POLICY</h1>
        <div className="policy-boxes">
          <div className="policy-box">
            <p> <span className='spantext'>1.</span><br/> Aspiring to be a leading service provider in the construction market in Sri Lanka.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>2.</span> <br/> Establishing, implementing, maintaining, and continually improving a quality management system aligned with ISO 9001:2015 to deliver high-quality products that exceed the expectations of our customers.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>3.</span> <br/> Conducting thorough market research to enhance our company's competitiveness through the continual improvement of product quality and service excellence.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>4.</span><br/> Embracing innovation by renewing and modernizing our equipment, applying cutting-edge technology in our production processes.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>5.</span><br/> Attracting top-tier, skilled professionals and reinforcing their capabilities through ongoing training initiatives.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>6.</span><br/> Striving for continuous enhancement of product quality and increased productivity.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>7.</span><br/> Fostering a positive work environment, promoting stability, and progressively improving the living standards of our staff.</p>
          </div>
          <div className="policy-box">
            <p> <span className='spantext'>8.</span><br/> Ensuring unanimous commitment to the implementation of our quality policies among all members of the Rupasinghe Steels team.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
